import { rankingItems } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">热播排行</h2>
          <p className="mt-3 text-sm text-foreground-600">全网热度和用户评分综合排名，实时更新</p>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer`}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-background-100 flex items-center justify-center flex-shrink-0">
                <span className={`text-lg md:text-xl font-bold font-heading ${
                  item.rank === 1 ? 'text-accent-500' :
                  item.rank === 2 ? 'text-secondary-500' :
                  item.rank === 3 ? 'text-primary-500' :
                  'text-foreground-400'
                }`}>
                  {item.rank}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-bold text-foreground-950 font-heading whitespace-nowrap">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded-md bg-background-200 text-xs text-foreground-600 whitespace-nowrap">{item.tag}</span>
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                  )}
                </div>
                <p className="mt-1 text-xs text-foreground-600">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <p className="text-lg font-bold text-accent-500 font-heading">{item.heat}</p>
                <p className="text-xs text-foreground-500">综合热度</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}